import {
	GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT,
	GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT,
	CREATE_GROUP_OVERSIGHT_PROJECT
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

const projectReducer = (state = initialstate.ovsProject, action) => {
	switch (action.type) {
		case GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT:
			if (isApiResponseOk(action)) {
				let result = action?.response
					?.map((m) => m.orgStructure?.map((e) => e.engagements))
					?.flat()
					?.flat()
					?.some((s) => s === parseInt(action.engagementId));
				return {
					...state,
					isProjectAssociated: result === undefined ? false : result,
					projects: action?.response?.filter(
						(f) =>
							f.users?.find((user) => user.userId === action.userId) ||
							f.owners?.find((user) => user.userId === action.userId)
					)
				};
			}
			return state;
		case GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT:
			if (isApiResponseOk(action)) {
				let result = action?.response
					?.map((m) => m.orgStructure?.map((e) => e.engagements))
					?.flat()
					?.flat()
					?.some((s) => s === parseInt(action.engagementId));
				return {
					...state,
					isOtherProjectAssociated: result === undefined ? false : result
				};
			}
			return state;
		case CREATE_GROUP_OVERSIGHT_PROJECT:
			return state;
	}
};

export default projectReducer;
